// Import the library
import * as pdfjsLib from 'pdfjs-dist/build/pdf';

// --- PDF.js Worker Setup ---
// Configure the worker source. This needs to be accessible by the browser.
// Using the file copied to the root by vite-plugin-static-copy or manually placed in /public
pdfjsLib.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`; // Or .js if that's what you are using

/**
 * Gets the number of pages in a PDF file.
 * @param {File} fileObject - The PDF file object.
 * @returns {Promise<number>} A promise that resolves with the number of pages.
 * @throws {Error} Throws an error if the file is invalid, password-protected,
 *                 or cannot be processed by pdf.js. Custom error messages are added.
 */
export const getPdfPageCount = async (fileObject) => {
  if (!fileObject) {
    throw new Error('No file provided.');
  }

  try {
    const arrayBuffer = await fileObject.arrayBuffer(); // Read file as ArrayBuffer
    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdfDocument = await loadingTask.promise;
    return pdfDocument.numPages; // Return the number of pages directly

  } catch (pdfError) {
      let errorMessage = `Could not read PDF structure. It might be corrupted or invalid.`;
      if (pdfError.name === 'PasswordException') {
           errorMessage = `Cannot process password-protected PDF.`;
      }
      // Re-throw a new error with a potentially more user-friendly message
      // or you could add properties to the error object.
      throw new Error(errorMessage);
  }
}; 